export default __webpack_public_path__ + "static/training-offer-b403b5402054c789b84248317fd668eb.png";